'use client';

import HeaderAuthedActions from '@/components/header/HeaderAuthedActions';
import ClubOneLogo from '@/components/logos/ClubOneLogo';
import {Button} from '@/components/ui/button';
import Link from 'next/link';
import {useEffect} from 'react';

export default function ErrorPage({error}: {error: Error & {digest?: string}}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <>
      <header className="header">
        <div className="header-container">
          <div className="flex flex-1 justify-center lg:block lg:flex-initial">
            <Link href="/">
              <h1>
                <ClubOneLogo />
                <span className="sr-only">Cochran ClubOne Rewards</span>
              </h1>
            </Link>
          </div>
          <HeaderAuthedActions />
        </div>
      </header>
      <main className="mainCenter">
        <div className="flex flex-col items-center text-center">
          <div className="mb-5 h-[200px] w-[200px] md:mb-8 md:h-[300px] md:w-[300px] lg:mb-10 lg:h-[400px] lg:w-[400px]">
            <svg
              width="500"
              height="500"
              viewBox="0 0 500 500"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="block h-full w-full"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M254.726 145.722L259.073 159.193L303.467 82.2961C318.313 56.568 355.324 56.568 370.169 82.2961L430.813 187.367C445.754 213.255 426.962 245.135 397.463 245.135H286.783L303.179 295.952L379.356 331.875C402.639 342.853 405.148 362.205 386.515 370.994L258.162 431.528C241.431 439.422 213.801 436.29 196.557 428.156L82.507 374.368C59.224 363.39 56.715 344.038 75.3479 335.249L158.684 295.954L207.137 145.74C214.631 122.537 247.231 122.534 254.726 145.722ZM345.27 217.186C355.609 217.186 354.746 206.063 354.746 201.014C354.746 188.629 338.974 191.522 328.363 191.522C317.864 191.522 318.871 202.756 318.871 207.694C318.887 220.11 334.66 217.186 345.27 217.186ZM328.811 113.154C323.346 113.154 318.887 117.612 318.887 123.078V174.181C318.887 176.914 320.006 179.407 321.795 181.196L321.811 181.18L328.811 184.105C338.479 184.105 354.763 187.013 354.763 174.181V123.077C354.763 110.309 338.415 113.154 328.811 113.154ZM340.412 127.504H333.237V169.755H340.412V127.504ZM264.984 177.568L282.147 230.783L397.461 230.767C401.968 230.767 406.106 229.68 409.622 227.667L409.606 227.651C413.154 225.605 416.174 222.569 418.427 218.67L418.443 218.686C422.869 210.984 422.885 202.178 418.443 194.492L418.427 194.508L357.783 89.4535C355.546 85.5703 352.526 82.5342 348.979 80.4727L348.995 80.4568C341.788 76.302 331.896 76.302 324.673 80.4568L324.689 80.4727C321.141 82.5342 318.121 85.5545 315.868 89.4535L264.984 177.568ZM266.774 229.695C255.476 231.229 243.171 231.996 230.946 231.996V231.964C218.626 231.964 206.321 231.197 195.103 229.679L176.758 286.551C205.858 294.796 256.003 294.796 285.118 286.551L266.774 229.695ZM199.56 215.84C209.5 217.071 220.223 217.678 230.945 217.678V217.646C241.716 217.646 252.438 217.039 262.298 215.824L241.093 150.1C237.881 140.144 223.978 140.128 220.766 150.1L199.56 215.84ZM289.495 300.15C257.39 309.386 204.465 309.37 172.36 300.15L157.003 347.739C155.437 352.613 162.356 357.04 173.494 360.635C188.372 365.429 209.593 367.826 230.91 367.826V367.794C252.292 367.794 273.513 365.397 288.326 360.619C299.464 357.023 306.4 352.581 304.817 347.723L289.495 300.15ZM309.198 314.612L318.482 343.376C329.461 377.397 255.986 382.16 230.945 382.16L230.929 382.128C205.825 382.128 132.412 377.382 143.392 343.36L152.66 314.612C143.951 318.719 80.2062 347.787 77.8417 350.711C75.3168 353.827 84.8089 359.628 88.6282 361.418L202.679 415.205C216.022 421.501 239.385 424.553 252.056 418.577C265.911 412.041 381.398 358.763 384.037 355.536C386.562 352.42 377.07 346.619 373.25 344.829L309.198 314.612Z"
                fill="#D81E36"
              />
            </svg>
          </div>
          <h2 className="mb-2 text-6xl md:mb-3 md:text-7xl lg:mb-4 lg:text-8xl">500</h2>
          <h3 className="text-3xl md:text-4xl lg:text-5xl">
            Hit the brakes! Something went wrong.
          </h3>
          <p className="mt-1 text-xl font-bold md:mt-2 lg:text-2xl">
            please try again later while we get things back on track
          </p>
          <Button asChild className="mt-4 md:mt-5 lg:mt-6">
            <Link href="/">Go Back</Link>
          </Button>
        </div>
      </main>
    </>
  );
}
